// EventHeader.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import PartnerList from "./PartnerList";

const EventHeader = ({ eventdetails, geteventactivities }) => {
  const { EventName, MainPicture, Lugar, EventDate, EventID } = eventdetails;

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: 400,
        borderRadius: "10px",
        overflow: "hidden",
        // Si MainPicture falla o no existe, la capa de abajo muestra el placeholder
        backgroundImage: `url(${MainPicture}), url('/images/placeholder-event.webp')`,
        backgroundColor: "#0A0A12",
        backgroundSize: "cover, cover",
        backgroundPosition: "center, center",
      }}
    >
      {/* Overlay v2 para legibilidad (IDENTIDAD_VISUAL.md §6) */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(180deg, rgba(10,10,18,0) 40%, rgba(10,10,18,.85) 100%)",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          left: 20,
          color: "#EDE9F7",
          zIndex: 2,
        }}
      >
        <Typography variant="h2" component="h1">
          {EventName}
        </Typography>
          
        <PartnerList eventID={EventID}/> {/* ✅ CORREGIDO */}
      </Box>
    </Box>
  );
};

export default EventHeader;